<template>
  <IQOS :title="$t('security_panel.title')" :readonly="editing">
    <RoundCheckbox v-model="security.require_phone" :readonly="!editing">
      {{ $t('security_panel.phone')}}
    </RoundCheckbox>
    <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="onEditFinish"
    />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";
import BlackInput from "@/components/BlackInput.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";

export default {
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    RoundCheckbox,
  },
  data() {
    return {
      editing: false,

      security: {
        require_phone: true,
      },
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.$store.commit("setCafeSecurity", this.security);
      this.$store.dispatch("saveCafe");
      this.editing = false;
    },
    reset() {
      if (this.cafe.security) {
        this.security = Object.assign({}, this.cafe.security);
      }
    },
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style>
</style>